import { AlertTriangle, X } from 'lucide-react';
import { useQuota } from '../context/QuotaContext';

export default function BetaWarning() {
    // Now purely reactive to the global QuotaContext
    const { isQuotaExceeded, resetQuota } = useQuota();

    // If no quota exceeded, do not show anything.
    if (!isQuotaExceeded) return null;

    return (
        <div className="bg-red-600 text-white px-4 py-3 text-sm font-medium flex items-center justify-between relative z-50 shadow-md">
            <div className="flex items-center gap-3 flex-1">
                <div className="p-1.5 bg-white/20 rounded-full animate-pulse">
                    <AlertTriangle size={20} className="shrink-0 text-white" />
                </div>
                <div>
                    <p className="font-bold uppercase tracking-wider text-xs text-red-100 mb-0.5">Service Interrompu</p>
                    <p className="leading-tight">
                        Le serveur subit une charge exceptionnellement élevée. Certaines fonctionnalités peuvent être indisponibles.
                    </p>
                </div>
            </div>
            <button onClick={resetQuota} className="p-2 hover:bg-white/20 rounded-lg transition ml-3 group" title="Fermer">
                <X size={18} className="group-hover:rotate-90 transition-transform" />
            </button>
        </div>
    );
}
